/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { createSelector, createSlice } from '@reduxjs/toolkit';
import { ThunkStatus } from '../../../enums/ThunkStatus';
import { sendInvitations } from './users.invite.thunk';

// MOVE TO INVITATION

/* Initial State */
const initialState = {
  status: ThunkStatus.IDLE,
  invitations: { roles: [], userIds: [], emailAddresses: [] },
  userInviteDialog: {
    open: false,
  },
  successDialog: {
    open: false,
  },
  error: undefined,
};

/* Slice */
export const inviteUsersSlice = createSlice({
  name: 'inviteUsers',
  initialState,
  reducers: {
    updateInvitations(state, action) {
      state.invitations = action.payload;
    },
    resetInvitations(state) {
      state.status = ThunkStatus.IDLE;
      state.invitations = { roles: [], userIds: [] };
      state.error = undefined;
    },
    toggleDialog(state, action) {
      state.userInviteDialog.open = action.payload;
    },
    toggleSuccessDialog(state, action) {
      state.successDialog.open = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(sendInvitations.pending, (state) => {
        state.status = ThunkStatus.LOADING;
      })
      .addCase(sendInvitations.fulfilled, (state) => {
        state.status = ThunkStatus.SUCCEEDED;
        state.invitations = { roles: [], userIds: [] };
        state.error = undefined;
        state.userInviteDialog.open = false;
        state.successDialog.open = true;
      })
      .addCase(sendInvitations.rejected, (state, action) => {
        state.status = ThunkStatus.FAILED;
        state.error = action?.error?.message;
      });
  },
});

/* Selectors */
const selectUsersInvite = state => state[inviteUsersSlice.name];
export const selectInvitations = createSelector(selectUsersInvite, s => s.invitations);
export const selectStatus = createSelector(selectUsersInvite, s => s.status);
export const selectDialog = createSelector(selectUsersInvite, s => s.userInviteDialog);
export const selectSuccessDialog = createSelector(selectUsersInvite, s => s.successDialog);

/* Actions */
export const { updateInvitations, resetInvitations, toggleDialog, toggleSuccessDialog } = inviteUsersSlice.actions;
